import { createClient } from "@supabase/supabase-js";
import { env } from "@/lib/env";

/**
 * The single Supabase client for the application.
 *
 * Constitution Article I: Supabase PostgreSQL is the single source of
 * truth. This client is the only sanctioned way the frontend talks to it.
 * Do not call createClient() anywhere else in the codebase — import this
 * instance instead, so auth state, realtime subscriptions, and request
 * headers stay consistent across the whole app.
 *
 * Authorization is enforced by Row Level Security policies on every table
 * (see database/migrations/). The anon key below is safe to ship to the
 * browser by design — it identifies the project, not a privilege level.
 */
export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "fi-radar-auth",
  },
});
